module.exports = __webpack_public_path__ + "static/img/ic.dc0d5bfc.svg";